<div class="p-2">
  <label [for]="id" class="font-weight-bold">{{ label }}</label>
  <input
    class="w-100"
    [id]="id"
    [name]="id"
    [placeholder]="placeholder"
    [required]="required"
    [type]="type"
    [(ngModel)]="value"
    (input)="onInputChange()"
    #input="ngModel"
  />
  <div
    class="text-danger"
    [ngClass]="
      input.invalid && (input.touched || searchForm.submitted)
        ? 'visible'
        : 'invisible'
    "
  >
    {{ validationErrorMessage }}
  </div>
</div>
